// extracted by mini-css-extract-plugin
module.exports = {"dialogSurface":"dialog_dialogSurface__F_2Yh","dialogCloseKeyframes":"dialog_dialogCloseKeyframes__ENFr1","dialogOpenKeyframes":"dialog_dialogOpenKeyframes__ZdswN"};